import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { VButtonComponent } from 'src/app/core/components/ui-kit/buttons/button/button.component';
import { VCardImageHeaderComponent } from 'src/app/core/components/ui-kit/card/card-headers/image-header.component';
import { VCardComponent } from 'src/app/core/components/ui-kit/card/card.component';
import { SharedModule } from 'src/app/core/shared.module';
import { FeaturesState } from 'src/app/store/features/features.state';
import { FLAGS } from 'src/app/store/features/flags';

@Component({
  selector: 'app-page-maintenance',

  imports: [
    SharedModule,
    VButtonComponent,
    VCardComponent,
    VCardImageHeaderComponent,
  ],
  templateUrl: './maintenance.component.html',
})
export class MaintenancePageComponent {
  store = inject(Store);
  router = inject(Router);

  public maintenanceEnabled$ = this.store.select(
    FeaturesState.boolFlag(FLAGS.HALO_PROTOCOL_FRONTENT)
  );

  returnToDashboard() {
    this.router.navigate(['/']);
  }
}
